import React, { useEffect, useRef, useState } from "react";
import { toast, ToastContainer } from 'react-toastify';

import "../../examSyllabus/css/examSyllabus.css";
import { getSyllabusClassesList } from './questionPaperSvc';

// Question Paper module ka apna SyllabusClasses (common examSyllabus wale ko touch na karne ke liye).
// Parent (questionPaperCtrl) apni syllabusListSvc deta hai, aur class chip select pe clsId bhi bhejta hai.
// Classes syllabus list ke response mein embedded nahi aate (Harry ka /list_syllabus sirf syllabusId+syllabus
// deta hai) — isliye syllabus select hone par alag se /sms/qp/v1/list_classes call karte hain.
const SyllabusClasses = (props) => {

    const { syllabusId, clsId, handleSyllabusChange, handleClassChange, setLoader, setOpacity, syllabusListSvc } = props;

    const scrollContainerRef = useRef(null);
    const [scrollPosition, setScrollPosition] = useState(0);
    const [lstSyllabus, setLstSyllabus] = useState([]);
    const [lstClsSection, setLstClsSection] = useState([]);
    // Harry ka /list_classes ek class ki saari sections ko ek row (csvSection) mein deta hai —
    // isliye alag-alag chips ko individually highlight karne ke liye apna local "kaunsa chip chuna"
    // track karte hain (clsId sabka same hota hai, sirf usse pata nahi chalta kaunsa specific chip tha).
    const [selectedChipKey, setSelectedChipKey] = useState("");

    useEffect(() => {
        // console.log("SyllabusClasses (qp) called");
        getSyllabusList();
    }, []);

    const getSyllabusList = () => {
        setLoader((prevLoader) => prevLoader + 1);
        setOpacity(0.5);
        syllabusListSvc(syllabusListReponse);
    }

    const syllabusListReponse = (data) => {
        // console.log("syllabusListReponse called, data", data);
        let obj = data;
        if (obj.status === 'Success') {
            setLstSyllabus(obj.lstSyllabus);
            if (obj.lstSyllabus && obj.lstSyllabus.length) {
                handleSyllabusChange(obj.lstSyllabus[0].syllabusId);
                getClassSectionList(obj.lstSyllabus[0].syllabusId);
                return; // loader neeche getClassSectionList ke response mein band hoga
            }
        }
        else {
            if (obj.message == 'You are not logged in') {
                setTimeout(function () {
                    window.location.href = "/";
                }, 2000);
                return false;
            }
            else if (obj.message == 'Your Session is expired, login again') {
                setTimeout(function () {
                    window.location.href = "/";
                }, 2000);
                return false;
            } else {
                toast.error(obj.message);
            }
        }
        setLoader((prevLoader) => prevLoader - 1);
        setOpacity(1);
    }

    const getClassSectionList = (pSybId) => {
        getSyllabusClassesList(pSybId, classSectionResponse);
    }

    const classSectionResponse = (data) => {
        // console.log("classSectionResponse called, data", data);
        if (data.status === 'Success') {
            const lstCls = data.lstClasses || [];
            setLstClsSection(lstCls);
            if (lstCls.length) {
                handleClassChange(lstCls[0].clsId);
                const firstSection = (lstCls[0].csvSection || "").split(",").map((s) => s.trim()).filter(Boolean)[0] || "";
                setSelectedChipKey(lstCls[0].clsId + "-" + firstSection);
            } else {
                handleClassChange(0);
                setSelectedChipKey("");
            }
        } else {
            setLstClsSection([]);
            setSelectedChipKey("");
            toast.error(data.message);
        }
        setLoader((prevLoader) => prevLoader - 1);
        setOpacity(1);
    }

    const updateSyllabusId = (pSybId) => {
        // console.log("updateSyllabusId, pSybId", pSybId);
        handleSyllabusChange(pSybId);
        handleClassChange(0);
        setLoader((prevLoader) => prevLoader + 1);
        setOpacity(0.5);
        getClassSectionList(pSybId);
    }

    return (
        <div className="col-sm-12 padding-remove">
            <div className="col-xs-3 ">
                <label
                    className="col-sm-3 text-left padding-remove"
                    style={{ top: "5px" }}
                >
                    Syllabus
                </label>
                <div className="form-group col-sm-9 padding-remove">
                    <select
                        className="form-control"
                        value={syllabusId}
                        onChange={(e) => updateSyllabusId(e.target.value)}
                    >
                        <option value={0}>Syllabus</option>
                        {lstSyllabus && lstSyllabus ?
                            lstSyllabus.map((syllabus) => (
                                <option
                                    key={syllabus.syllabusId}
                                    value={syllabus.syllabusId}>
                                    {syllabus.syllabus}
                                </option>
                            ))
                            : null
                        }
                    </select>
                </div>
            </div>
            <div className="col-xs-9 ">
                <div className="scroll-container" style={{ margin: "5px 0 0 0", border: "none", overflowX: "auto", overflowY: "hidden" }}>
                    {lstClsSection && lstClsSection.length > 0 && (
                        <div style={{ display: "flex", flexDirection: "row", }}>
                            <div className="scroll-content" ref={scrollContainerRef}>
                                {lstClsSection.flatMap((clsSec) =>
                                    (clsSec.csvSection || "").split(",").map((s) => s.trim()).filter(Boolean).map((section) => {
                                        const chipKey = clsSec.clsId + "-" + section;
                                        return (
                                            <div
                                                style={{ minWidth: "150px", height: "30px", border: "1px solid #ccc", borderRadius: "25px", margin: "0 2px" }}
                                                className={(chipKey === selectedChipKey) ? "selected col-sm-2 padding-remove" : "col-sm-2 padding-remove"}
                                                onClick={() => { handleClassChange(clsSec.clsId); setSelectedChipKey(chipKey); }}
                                                key={chipKey}
                                            >
                                                <div style={{ padding: "3px 10px", justifyContent: "center", whiteSpace: "nowrap" }}>
                                                    {clsSec.cls + " - " + section}
                                                </div>
                                            </div>
                                        );
                                    })
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default SyllabusClasses;
